import domReady from "@wordpress/dom-ready";
import loader from "./scripts";
import {
  scrollbarWidth,
  resize,
  consoleString,
  containers,
  sleep,
} from "./scripts/utils";

import { initRellax, initAOS } from "./scripts/animations/index.ts";

// The menu script is loaded on every page.
// No requirement to load it dynamically.
import { desktopMegaMenu, footerMenu, jsMenu, menuDecorator, mobileMegaMenu } from "./scripts/menus/index.ts";

// The form decorators act on content in the footer, so are loaded on every page.
// No requirement to load them dynamically.
import { decorateForms } from "./scripts/utils/forms.ts";

const buttonRipplesInit = async () => {
  //  Burst effect for button
  const buttons = document.querySelectorAll(".button");
  if (buttons.length) {
    const { rippleEffect } = await import("./scripts/buttons/index.ts");
    buttons.forEach((item) => {
      item.addEventListener("click", (event) => {
        rippleEffect(item, event);
      });
    });
  }
};

const sbRevealsInit = async () => {
  const sbReveals = document.querySelectorAll(".reveal-line");
  if (sbReveals.length) {
    console.time("✅ line animation scripts loaded in");
    const importUrl = "animations/lines";
    await import(`./scripts/${importUrl}.ts`)
      .then((mod) => {
        console.timeEnd("✅ line animation scripts loaded in");
        mod.lineAnimationInit(sbReveals);
      })
      .catch((err) => {
        console.log(
          `%c❌ an error occurred while loading ${importUrl}\n`,
          consoleString.error,
          err
        );
      });
  }
};

const revealsInit = async () => {
  const revealsList = document.querySelectorAll(".reveal");
  if (revealsList.length) {
    console.time("✅ reveal animation scripts loaded in");
    const importUrl = "animations/reveal";
    await import(`./scripts/${importUrl}.ts`)
      .then((mod) => {
        console.timeEnd("✅ reveal animation scripts loaded in");
        mod.revealInit(revealsList);
      })
      .catch((err) => {
        console.log(
          `%c❌ an error occurred while loading ${importUrl}\n`,
          consoleString.error,
          err
        );
      });
  }
};

const accordionsInit = async () => {
  if (document.querySelectorAll(".sb-accordion").length) {
    // TODO: translate this script to one similar to the newer dynamic imports.
    // This still works as intended, only loading the script when required.
    loader.loadScript({
      type: "accordions",
      isUtil: false,
      isTypeScript: true,
    });
  }
};

const carouselsInit = async () => {
  if (document.querySelectorAll(".sb-carousel").length) {
    // TODO: translate this script to one similar to the newer dynamic imports.
    // This still works as intended, only loading the script when required.
    loader.loadScript({
      type: "carousels",
      isUtil: false,
      isTypeScript: true,
    });
  }
};

const squigglesInit = async () => {
  if (document.querySelectorAll("u").length) {
    loader.loadScript({
      type: "squiggles",
      isUtil: false,
      isTypeScript: false,
    });
  }
};

const filtersInit = async () => {
  if (document.querySelectorAll(".sb-c-category-list").length) {
    loader.loadScript({
      type: "articleFilters",
      isUtil: false,
      isTypeScript: true,
    });
  }
};

const navInit = async () => {
  if (document.querySelectorAll("nav.sb-c-main-nav").length) {
    loader.loadScript({
      type: "nav",
      isUtil: false,
      isTypeScript: true,
    });
  }
};

const statSigInit = async () => {
  loader.loadScript({
    type: 'statSig',
    isUtil: false,
    isTypeScript: false
  })
}

// js accordion start

// sbCssVarSet("--sb-accordion-bar-height", "500px");

document.querySelectorAll(".jsAccordion").forEach((jsAccordion) => {
  // add click event listener
  jsAccordion.addEventListener("click", (event) => {
    // event.preventDefault();
    const isHeadlineClicked = event.target.classList.contains(
      "sb-c-content-accordion__headline"
    );

    if (isHeadlineClicked) {
      const parent = jsAccordion.closest(".sb-c-content-accordion__item");
      const activeClass = "sb-c-content-accordion__item--active";

      const isActive = parent.classList.contains(activeClass);

      // Close all accordions
      document
        .querySelectorAll(".sb-c-content-accordion__item")
        .forEach((item) => {
          item.classList.remove(activeClass);
          const body = item.querySelector(".sb-c-content-accordion__body");
          if (body) {
            jQuery(body).slideUp();
          }
        });

      // If clicked accordion was not active, open it
      if (!isActive) {
        parent.classList.add(activeClass);
        const body = parent.querySelector(".sb-c-content-accordion__body");
        if (body) {
          jQuery(body).slideDown();
        }
      }
    } else if (event.target.closest(".sb-c-content-accordion__body a")) {
      return;
    }
    event.preventDefault();
  });
});

//
// js accordion end
//
domReady(() => {
  console.log(
    "%csitback %cwebsite ready",
    consoleString.hero,
    consoleString.normal
  );

  navInit();
  accordionsInit();
  buttonRipplesInit();
  carouselsInit();
  containers();
  // TODO: figure out what this actually achieves, and whether it could be achieved better via templating.
  filtersInit();
  initAOS();
  initRellax();
  jsMenu(); // trigger the mobile menu functionality
  mobileMegaMenu(); // allow animated underlines on main menu hover
  desktopMegaMenu(); // allow animated underlines on main menu hover
  footerMenu();
  revealsInit();
  sbRevealsInit();
  scrollbarWidth(); // run initial detection of scrollbars
  squigglesInit();
  statSigInit()

  resize({
    // on resize, update the scrollbar width value
    selector: ".sb-page-wrapper", // running this on <body> failed to detect content changes.
    callback: scrollbarWidth, // this is the callback that will run when a change is detected.
    active: true, // we can turn the observer on or off with this flag.
  });
});

sleep(2000).then(() => {
  // We need to give the Hubspot stuff time to load in.
  // AFAIK it does not throw any events to hook into.
  decorateForms();
});
